import { getUrlDefaults } from '~/src/Lib/Nav'

import entity from './bundle'

export const urls = getUrlDefaults('pesticideApplications')
export { default as list } from './list'
export default entity
